import { Box, BoxProps } from '@mantine/core'
import useStyles from './index.styles'
import { Text } from '@hhgtech/hhg-components/mantine'
import { useRouterExtend } from 'hooks/useRouterExtend'

type Props = {
  score: number
  status: string
  unit?: string
  color?: string
} & BoxProps

export const ResultCard = ({
  score,
  status,
  unit,
  color,
  styles,
  classNames,
  className,
  ...boxProps
}: Props) => {
  const { locale } = useRouterExtend()
  const { classes, cx } = useStyles(
    { color },
    {
      name: 'IntroToolsBanner__ResultCard',
      styles,
      classNames,
    },
  )
  return (
    <Box className={cx(className, classes.root)} {...boxProps}>
      <div className={classes.scoreArea}>
        <span className={classes.score}>
          {Number(score).toLocaleString(locale)}
        </span>
        {unit && (
          <Text size="p4" as="span" className={classes.unit}>
            {unit}
          </Text>
        )}
      </div>
      <Text size="p4">{status}</Text>
    </Box>
  )
}
